<div class="col-12 flex flex-wrap" *ngIf="!showBtnCandidate">
  <div class="card w-full">
    <p-messages [(value)]="message" [enableService]="false" [closable]="false"></p-messages>
  </div>
</div>
<p-panel header="Informazioni pricipali">
    <div class="col-12 flex flex-wrap">
      <div class="col-12 flex">
        <label class="labelWidth font-bold">Titolo</label>
        <label class="w-full" style="appearance: auto">{{jobPostSelected.Titolo}}</label>
      </div>
    </div>
    <div class="col-12 flex flex-wrap">
      <div class="col-12 flex">
        <label class="labelWidth font-bold">Job Description</label>
        <label class="w-full" style="appearance: auto; overflow: auto">{{jobPostSelected.Descrizione}}</label>
      </div>
    </div>
    <div class="col-12 flex flex-wrap">
      <div class="col-12 flex">
        <label class="labelWidth font-bold">Luogo di Lavoro</label>
        <label class="w-full" style="appearance: auto">{{jobPostSelected.ComuneNome}}</label>
      </div>
    </div>
<!--    <div class="col-12 flex flex-wrap">-->
<!--      <div class="col-12 flex">-->
<!--        <label class="labelWidth font-bold"> Frazione </label>-->
<!--        <label class="w-full" style="appearance: auto">{{jobPostSelected.Luogo}}</label>-->
<!--      </div>-->
<!--    </div>-->
<!--    <div class="col-12 flex flex-wrap">-->
<!--      <div class="col-12 flex">-->
<!--        <label class="labelWidth font-bold"> Posizioni ricercate </label>-->
<!--        <label class="w-full" style="appearance: auto">{{jobPostSelected.NrLavoratori}}</label>-->
<!--      </div>-->
<!--    </div>-->
    <div class="col-12 flex flex-wrap">
      <div class="col-12 flex">
        <label class="labelWidth font-bold"> Tipo contratto</label>
        <label class="w-full" style="appearance: auto">{{jobPostSelected.TipoContratto}}</label>
      </div>
    </div>
    <div class="col-12 flex flex-wrap">
      <div class="col-12 flex">
        <label class="labelWidth font-bold"> Orario </label>
        <label *ngIf="jobPostSelected.Orario != null" class="w-full" style="appearance: auto">{{jobPostSelected.OrarioDesc}}</label>
      </div>
    </div>
    <div class="col-12 flex flex-wrap">
      <div class="col-12 flex">
        <label class="labelWidth font-bold">Esperienza Minima</label>
        <label class="w-full" style="appearance: auto">{{jobPostSelected.EsperienzaDurata}}</label>
      </div>
    </div>
    <div class="col-12 flex flex-wrap">
      <div class="col-12 flex">
        <label class="labelWidth font-bold"> Smart working </label>
        <label class="w-full" style="appearance: auto" *ngIf="jobPostSelected.SmartWorking == false"> NO </label>
        <label class="w-full" style="appearance: auto" *ngIf="jobPostSelected.SmartWorking == true"> SI </label>
      </div>
    </div>
<!--    <div class="col-12 flex flex-wrap">-->
<!--      <div class="col-12 flex">-->
<!--        <label class="labelWidth font-bold">Scadenza</label>-->
<!--        <label class="w-full" style="appearance: auto">{{jobPostSelected.DataScadenzaStr}}</label>-->
<!--      </div>-->
<!--    </div>-->
</p-panel>
  <br>

<p-panel header="Requisiti" *ngIf="jobPostSelected.studyTypeSelected != '' ||
             jobPostSelected.attestatiSelected != '' ||
             jobPostSelected.languageKnowledgesSelected != '' ||
             jobPostSelected.computerKnowledgesSelected != ''">
    <div *ngIf="jobPostSelected.studyTypeSelected != ''">
      <div class="col-12 flex flex-wrap">
        <div class="col-12 flex">
          <label class="labelWidth font-bold"> Istruzione </label>
          <label class="w-full" style="appearance: auto">{{jobPostSelected.studyTypeSelected}}</label>
        </div>
      </div>
    </div>
    <div *ngIf="jobPostSelected.attestatiSelected != ''">
      <div class="col-12 flex flex-wrap">
        <div class="col-12 flex">
          <label class="labelWidth font-bold"> Attestati / Specializzazioni </label>
          <label class="w-full" style="appearance: auto">{{jobPostSelected.attestatiSelected}}</label>
        </div>
      </div>
    </div>
    <div *ngIf="jobPostSelected.languageKnowledgesSelected != ''">
      <div class="col-12 flex flex-wrap">
        <div class="col-12 flex">
          <label class="labelWidth font-bold"> Conoscenze Linguistiche   </label>
          <label class="w-full" style="appearance: auto">{{jobPostSelected.languageKnowledgesSelected}}</label>
        </div>
      </div>
    </div>
    <div *ngIf="jobPostSelected.computerKnowledgesSelected != ''">
      <div class="col-12 flex flex-wrap">
        <div class="col-12 flex">
          <label class="labelWidth font-bold"> Conoscenze Informatiche </label>
          <label class="w-full" style="appearance: auto">{{jobPostSelected.computerKnowledgesSelected}}</label>
        </div>
      </div>
    </div>
  </p-panel>
  <br>
<p-panel header="Filiale" *ngIf="jobPostSelected.FilialeCommessa != ''">
  <div class="col-12 flex flex-wrap">
    <div class="col-12 flex">
      <label class="labelWidth font-bold"> Nome Filiale </label>
      <label class="w-full" style="appearance: auto">{{jobPostSelected.FilialeCommessa}}</label>
    </div>
  </div>
  <div *ngIf="jobPostSelected.Indirizzo != ''">
    <div class="col-12 flex flex-wrap">
      <div class="col-12 flex">
        <label class="labelWidth font-bold"> Indirizzo </label>
        <label class="w-full" style="appearance: auto">{{jobPostSelected.Indirizzo}}</label>
      </div>
    </div>
  </div>
  <div *ngIf="jobPostSelected.Telefono != ''">
    <div class="col-12 flex flex-wrap">
      <div class="col-12 flex">
        <label class="labelWidth font-bold"> Telefono</label>
        <label class="w-full" style="appearance: auto">{{jobPostSelected.Telefono}}</label>
      </div>
    </div>
  </div>
  <div *ngIf="jobPostSelected.Mail != ''">
    <div class="col-12 flex flex-wrap">
      <div class="col-12 flex">
        <label class="labelWidth font-bold"> Mail </label>
        <label class="w-full" style="appearance: auto">{{jobPostSelected.Mail}}</label>
      </div>
    </div>
  </div>
</p-panel>

  <br>

<div class="texts text-sm mt-2 w-full">
  La ricerca è effettuata da Sapiens Spa Agenzia per il Lavoro (Aut. Min. 07/08/2013 prot. 0010585), in conformità alle norme vigenti in tema di trattamento dei dati personali (L. 196/3003 e GDPR 2016/679),
  l'informativa completa sulla privacy è reperibile sul sito www.sapienslavoro.it. La ricerca è rivolta ad entrambi i sessi ai sensi delle leggi 903/77 e 125/91 e a persone di tutte le età e tutte le nazionalità, ai sensi dei decreti legislativi 215/03 e 216/03. La ricerca è inoltre effettuata nel rispetto degli artt. 9 - 10 del D.lgs. 276/2003.
</div><br>

  <div class="w-full flex justify-content-end">
    <div class="col-4 xl:col-2 flex justify-content-end">
      <button pButton pRipple label="Chiudi" class="mt-4 w-full p-button-rounded p-button-danger" (click)="closeDialogDetails()"></button>
    </div>
    <div class="col-4 xl:col-2 flex justify-content-end" *ngIf="showBtnCandidate">
      <button pButton pRipple label="Candidati" class="mt-4 w-full p-button-rounded" (click)="insertCandidatura()"></button>
    </div>
  </div>
